import { useEffect, useState } from 'react';

const useToken = user => {
    const [token, setToken] = useState('');
    useEffect(()=>{
        const email = user?.user?.email;
        const currentUser = {email:email};
        if(email){
            fetch(`https://dps.onrender.com/user/${email}`, {
                method: 'PUT',
                headers:{
                    'content-type':'application/json'
                },
                body: JSON.stringify(currentUser)
            })
            .then(response => response.json())
            .then(data => {
                console.log('data inside token', data);
                const accessToken = data.token;
                localStorage.setItem('accessTokenForDoctorPortal', accessToken);
                setToken(accessToken);
            })
        }

    },[user]);
    return [token];
};

export default useToken;